'use client';

import {
  LayoutSidebarLeft,
  LayoutSidebarLeftDock,
  LayoutSidebarRight,
  LayoutSidebarRightDock,
} from '@lichtblick/icons';

import { SidebarControlButton } from './SidebarControlButton';

import { SidebarControlsContainer } from '../PanelLayout.styles';
import { usePanelLayout } from '../PanelLayoutContext';

type SidebarControlsProps = {
  $mobileRightAligned?: boolean;
};

export const SidebarControls = ({ $mobileRightAligned }: SidebarControlsProps) => {
  const { hasLeftSidebar, hasRightSidebar, isLeftCollapsed, isRightCollapsed, toggleLeftSidebar, toggleRightSidebar } =
    usePanelLayout();

  return (
    <SidebarControlsContainer $mobileRightAligned={$mobileRightAligned}>
      <SidebarControlButton
        $active={!isLeftCollapsed}
        $visible={hasLeftSidebar}
        aria-hidden={!hasLeftSidebar}
        aria-label="Toggle left sidebar"
        disabled={!hasLeftSidebar}
        hoverChildren={<LayoutSidebarLeftDock />}
        onClick={toggleLeftSidebar}
        tabIndex={hasLeftSidebar ? 0 : -1}
        type="button"
      >
        <LayoutSidebarLeft />
      </SidebarControlButton>
      <SidebarControlButton
        $active={!isRightCollapsed}
        $visible={hasRightSidebar}
        aria-hidden={!hasRightSidebar}
        aria-label="Toggle right sidebar"
        disabled={!hasRightSidebar}
        hoverChildren={<LayoutSidebarRightDock />}
        onClick={toggleRightSidebar}
        tabIndex={hasRightSidebar ? 0 : -1}
        type="button"
      >
        <LayoutSidebarRight />
      </SidebarControlButton>
    </SidebarControlsContainer>
  );
};
